import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';

import { Container } from '@/atoms';

import { SuscriptionForm } from '@/molecules';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import { closeNewsletterPopUp } from '@/lib/newsletterPopUp';

const ModalSuscripcion = ({ }) => {
  const newsletterPopUp = useSelector((state: RootState) => state.newsletterPopUp);
  const dispatch = useDispatch();
  return (
    <Dialog
      className="fixed inset-0 z-10 overflow-y-auto"
      onClose={() => dispatch(closeNewsletterPopUp())}
      open={newsletterPopUp.visible}
      transition
    >
      <div className="flex items-center justify-center min-h-screen px-4 text-center md:w-full bg-neutral-900 ">
        <DialogBackdrop transition className="fixed inset-0 bg-black opacity-80 transition ease-out duration-300 data-[closed]:opacity-0 data-[leave]:ease-in data-[leave]:duration-200" />
        <DialogPanel transition className="transition ease-out duration-300 data-[closed]:opacity-0 data-[closed]:scale-95 data-[leave]:ease-in data-[leave]:duration-200 min-w-[90%] max-w-[650px] md:min-w-[auto] md:w-[650px] transform bg-white text-left align-middle shadow-xl">
          <Container wrapper padding="pt-8" backgroundColor="bg-white">
            <div className="modal-header flex flex-shrink-0 justify-end">
              <button
                type="button"
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => dispatch(closeNewsletterPopUp())}
              >
                x
              </button>
            </div>
            <div className="grid grid-rows-[100px_minmax(170px,_1fr)_50px] grid-cols-[100%] p-10">
              <p className="text-headline--h3 text-center">
                Suscríbete a nuestra newsletter
              </p>
              <SuscriptionForm
                backgroundColor="#ffffff"
                title="Datos de suscripción"
                emailLabel="Email"
                defaultEmail={newsletterPopUp.email}
                lastNameLabel="Apellidos"
                messageLabel="Mensaje"
                nameLabel="Nombre"
                textButton="Aceptar"
              />
            </div>
          </Container>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default ModalSuscripcion;
